import React from "react";
import "./PartnersRuler.css";

function PartnersRuler() {
  return (
    <footer className="partners-ruler">
      <div className="partners-ruler-inner">
        <span className="partners-ruler-label">
          REALIZAÇÃO E PARCERIA
        </span>

        <img
          src="/assets/regua-de-parceiros.png"
          alt="IMA, Hub Acre, SEICT e Governo do Acre"
          loading="lazy"
        />
      </div>
    </footer>
  );
}

export default PartnersRuler;
